import { observer } from 'mobx-react';
import { NonEmptyList } from 'nonempty-list';
import * as React from 'react';
import { LearningPartnerResource } from '../../../../LearningPartnersStore/Types';
import { T } from '../../../../Translations';
import * as style from '../../style.module.css';

interface Props {
  learningPartners: NonEmptyList<LearningPartnerResource>;
}

const LearningPartnersHeader: React.FC<Props> = ({ learningPartners }) => (
  <h2 className={style.supPanelHeader}>
    <T kind="Learning Partner" count={learningPartners.length} />
  </h2>
);

export default observer(LearningPartnersHeader);
